import React from 'react'
import { Hammer } from 'lucide-react'
import { HeadingWithIcon } from '../../../../Components/Utils/Settingheading'
import Validity from './validity'

const IndexValidity = () => {
  return (
    <div>
      
             <HeadingWithIcon icon={Hammer} title="Quotation" />

    <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
   
    
     <div className=' w-full md:w-1/2 lg:w-1/3 '>
        <Validity/>
     </div> 
     
    
   
     </div>
     
     </div>
  )
}

export default IndexValidity